import type { PlatformOverviewResponse } from '@jq4race/shared';

import { request } from './client.js';

// role-based-dashboards — Phase 4. GET /super-admin/overview: a single
// snapshot fetch (org counts/distribution, plan distribution, subscription
// aggregates + MRR) backing the super_admin platform overview page. No
// polling/auto-refresh (spec "Snapshot-Only Super Admin Overview") — callers
// should fetch once per page load/navigation.
export async function getPlatformOverview(): Promise<PlatformOverviewResponse> {
  return request<PlatformOverviewResponse>('/super-admin/overview', { method: 'GET' });
}
